export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Управленческие переговоры — тренинг для руководителей",
        "description": "Тренинг по управленческим переговорам для руководителей: сложные разговоры, договорённости, конфликты, влияние, переговоры с сотрудниками и руководством. Практическое корпоративное обучение.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/upravlencheskie-peregovory",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Обучение управленческим переговорам",
        "description": "Корпоративное обучение руководителей и управленческих команд навыкам управленческих переговоров: подготовка к переговорам, формулирование позиции, работа с возражениями, влияние, удержание позиции и фиксация договорённостей в переговорах с сотрудниками, коллегами, собственниками и руководством.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение управленческим переговорам, переговоры руководителя, переговоры с сотрудниками, развитие управленческих компетенций",
        "url": "https://business-training.by/menedzhment-i-liderstvo/upravlencheskie-peregovory"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое управленческие переговоры?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Управленческие переговоры — это рабочий инструмент руководителя для достижения договорённостей с сотрудниками, коллегами, собственниками и вышестоящим руководством. Это не только разговоры о зарплате или должности, а любое взаимодействие, где нужно согласовать сроки, ответственность, результат, ресурсы или изменение поведения. Руководитель ведёт переговоры постоянно: при постановке задач, обсуждении KPI, разрешении конфликтов и внедрении изменений."
            }
          },
          {
            "@type": "Question",
            "name": "Чем управленческие переговоры отличаются от обычных переговоров?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обычные переговоры — чаще разовые сделки с клиентами или партнёрами, где стороны могут разойтись после сделки. Управленческие переговоры встроены в долгосрочные рабочие отношения: руководитель и сотрудник продолжают работать вместе. Поэтому здесь важнее не «победить» в разговоре, а сохранить ответственность, мотивацию и способность сотрудника работать дальше, одновременно добившись выполнения договорённостей."
            }
          },
          {
            "@type": "Question",
            "name": "В каких ситуациях руководителю нужны переговорные навыки?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Практически в ежедневной работе: при постановке задач и согласовании сроков, при обсуждении результатов и KPI, при распределении ответственности и ресурсов, при невыполнении договорённостей, при работе со сложными сотрудниками, при разрешении конфликтов, при внедрении изменений и при обсуждении непопулярных решений. Везде, где нужен не приказ, а принятая договорённость."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю договариваться с сотрудниками?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Начинать с подготовки: определить цель разговора, интересы сторон и желаемый результат. Затем ясно сформулировать позицию и ожидания, говорить о конкретных фактах, а не обобщениях, задавать вопросы и слушать ответы. Важно отделять позицию сотрудника от его реального интереса и переводить разговор в конкретные договорённости: действия, сроки и критерии результата."
            }
          },
          {
            "@type": "Question",
            "name": "Как вести переговоры с конфликтным сотрудником?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сохранять рабочую позицию и не переходить на личности, говорить о конкретном поведении и его последствиях, а не о характере человека. Выяснять, что стоит за сопротивлением — реальное несогласие, непонимание задачи или попытка избежать ответственности. Удерживать фокус на задаче и результате, не позволяя перевести разговор в эмоциональный спор, и фиксировать договорённости письменно."
            }
          },
          {
            "@type": "Question",
            "name": "Как добиться выполнения договорённостей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ключ — конкретность и контроль. Договорённость должна включать конкретное действие, срок и критерий результата, а не общие обещания «исправиться». Важно, чтобы стороны одинаково понимали, о чём договорились, и зафиксировать это. Затем руководитель проверяет выполнение в контрольной точке. Если договорённость нарушается, нужно возвращаться к ответственности сотрудника, а не молча переделывать за него."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю вести жёсткие переговоры?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Жёсткость руководителя — это не агрессия и не давление должностью, а способность сохранять позицию, границы и ответственность за результат. Это умение спокойно обозначить последствия невыполнения договорённостей, не поддаваться на манипуляции и эмоциональное давление, не отказываться от важных требований и доводить разговор до конкретного решения."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли научиться управленческим переговорам на тренинге?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, переговорные навыки — это практический навык, который отрабатывается. На тренинге участники не просто слушают теорию, а тренируются на реальных управленческих ситуациях: ролевые переговоры, разбор кейсов, анализ собственных формулировок и отработка удержания позиции. Обучение строится вокруг практики, а не лекций."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а комплексная управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики задач компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Сначала мы разбираемся, с какими переговорными ситуациями реально сталкиваются руководители компании: сложные сотрудники, конфликты между отделами, переговоры с руководством. После этого программа настраивается под уровень участников и специфику бизнеса, а реальные кейсы встраиваются в отработку."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли программа для новых руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Новые руководители часто впервые сталкиваются с необходимостью договариваться с бывшими коллегами, проводить сложные разговоры и удерживать управленческую позицию без опоры на личный авторитет. Программа даёт базовые переговорные инструменты и практическую отработку, которая помогает быстрее освоить новую роль."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли добавить сопровождение после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. После обучения при необходимости проводится сопровождение: разбираются реальные переговоры и сложные ситуации, возникшие в работе руководителей, корректируются действия и закрепляются навыки. При системной работе определяется, изменилось ли управленческое поведение и качество взаимодействия."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}